var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.isSelected,{tag:"component",on:{"switchPanel":function($event){return _vm.switchP($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }